import Swiper from "swiper";
import Plyr from "plyr";

export default class LandingPage {
  constructor() {
    this.init();
  }

  init() {
    const swiper = new Swiper(".landing-form .swiper.swiper-desk", {
      speed: 400,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      loop: true,
    });

    $(".landing-form .prev").on("click", function () {
      swiper.slidePrev();
    });

    $(".landing-form .next").on("click", function () {
      swiper.slideNext();
    });

    const swipermob = new Swiper(".landing-form .swiper.swiper-mob", {
      speed: 400,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      loop: true,
    });

    $(".landing-form .slider-nav-mob.prev").on("click", function () {
      swipermob.slidePrev();
    });

    $(".landing-form .slider-nav-mob.next").on("click", function () {
      swipermob.slideNext();
    });

    // $('.page-template-template-landing-page .modal-video').each(function () {
    //   const player = new Plyr(this);
    // });

    var player;
    $(".page-template-template-landing-page .video-trigger").on(
      "click",
      function () {
        var id = $(this).attr("data-id");
        $("html").css("overflow", "hidden");
        player = new Plyr('.plyr[data-num="' + id + '"]');
        player.play();
        $("#video-" + id)
          .css("display", "flex")
          .hide()
          .fadeIn();
      }
    );

    $(".video-modal .close").on("click", function () {
      $(".video-modal").fadeOut();

      player.destroy();

      $("html").css("overflow", "scroll");
    });

    if ($(".page-template").hasClass("page-template-template-landing-page")) {
      const prodApiUrl = "https://booking.rocksteadymusicschool.com/api";
      const stagingApiUrl = "https://staging.rocksteadymusicschool.com/api";

      const currentDomain = window.location.hostname;
      const isLive  = currentDomain.includes("rocksteadymusicschool.com")
      const apiUrl = isLive
        ? prodApiUrl
        : stagingApiUrl;

      let schools = [];
      let schoolName = "";
      let schoolPostcode = "";
      let schoolURN = "";

      let searchTimeout = null;

      let schoolSelected = false;
      let searching = false;

      function findSchool(schoolName) {
        searching = true;
        schoolSelected = false;

        // Fetch Schools
        $.ajax({
          url: apiUrl + "/schools/find?q=" + schoolName,
          type: "GET",
          success: function (response) {
            schools = response;
            searching = false;
            displaySchools();
            $(".schoolNameSearch .spinner").addClass("opacity-0");
          },
          error: function (error) {
            searching = false;
            console.log("Error: ", error);
          },
        });
      }

      function displaySchools() {
        // Clear Schools
        $(".schoolNameSearchContainer").html("").hide();

        // Load Schools into the DOM
        schools.forEach((school) => {
          // Build div with data
          let schoolDiv = $(
            '<div class="p-2 hover:bg-gray-100 cursor-pointer">' +
              school.name +
              "</div>"
          );

          schoolDiv.on("click", function () {
            schoolSelected = true;
            schoolURN = school.id;
            schoolName = school.name;

            // Update Form
            $(".schoolNameSearch input").val(schoolName);
            $('input[name="school_urn"]').val(schoolURN).attr("readonly", true);
            $(".schoolNameSearchContainer").html("").hide();
          });

          // Append to container
          $(".schoolNameSearchContainer").append(schoolDiv).show();
        });
      }

      function validateForm(form) {
        let isValid = true;
        $(".input-error-message").remove(); // Remove previous error messages
        $('.form-error').addClass('hidden').html(''); // Hide form error message.

        // Validate required text inputs and select fields
        $("input[required], select[required]").each(function () {
          let fieldError = $(this).attr("data-error")
          if ( ! fieldError ) {
            fieldError = "Please enter ";
            fieldError += $(this).attr("placeholder") || $(this).prev("label").text() || "this field";
          }
          if ($.trim($(this).val()) === "") {
            isValid = false;
            $(this).addClass('input-error');
            $(this).after(`<p class="input-error-message">${fieldError}</p>`);
          } else {
            $(this).removeClass('input-error');
          }
        });

            // Validate email format
            let email = $("input[name='email']");
            let emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailPattern.test(email.val())) {
                isValid = false;
                email.addClass('input-error');
                email.after(`<p class="input-error-message">Please enter a valid email address</p>`);
            }

            // Validate phone number (if entered, must be numeric)
            let phone = $("input[name='phone']");
            let phonePattern = /^[0-9+\-\s()]+$/;
            if (phone.val() && !phonePattern.test(phone.val())) {
                isValid = false;
                phone.addClass('input-error');
                phone.after(`<p class="input-error-message">Please enter a valid phone number</p>`);
            }

            // Ensure Privacy Policy checkbox is checked
            if (!$("#contact-by-email").is(":checked")) {
                isValid = false;
                //$("#contact-by-email").next("label").addClass('text-red-alert');
                $("#contact-by-email").parent().append(`<p class="input-error-message">You must accept the Privacy Policy</p>`);
            } else {
                //$("#contact-by-email").next("label").removeClass('text-red-alert');
            }
        return isValid;
      }

      $(document).ready(function () {
                // Remove error styling and messages on input change
                $("form").on("input change", "input, select", function () {
                  $(this).removeClass('input-error');
                  $(this).next(".input-error-message").remove();
              });

              $("#contact-by-email").on("change", function () {
                  if ($(this).is(":checked")) {
                      $(this).parent().find(".input-error-message").remove();
                  }
        });
        // Hide School Name Search Container
        $(".schoolNameSearchContainer").hide();

        // Set form date min attribute
        let today = new Date().toISOString().split("T")[0];
        $("#form_date").attr("min", today);

        // Set future date 6 months from now
        let monthsinFuture = 6;
        let futureDate = new Date();
        futureDate.setMonth(futureDate.getMonth() + monthsinFuture);
        futureDate = futureDate.toISOString().split("T")[0];
        $("#form_date").attr("max", futureDate);

        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);

        console.log(urlParams);

        console.log(urlParams.get("utm_campaign"));
        console.log(urlParams.get("utm_medium"));
        console.log(urlParams.get("utm_source"));
        console.log(urlParams.get("utm_content"));

        // Form Submission
        $(".leadForm").submit(function (e) {
          e.preventDefault();
          console.log("Form Submitted");
          const is_valid = validateForm($(this));

          if ( ! is_valid ) {
            return;
          }

          // Get Preferred Call Back Time and format to “2024-07-22T11:00:00Z”
          let preferred_call_back_time = null;
          if ($("#form_date").val() && $("#form_time").val()) {
            preferred_call_back_time =
              $("#form_date").val() + "T" + $("#form_time").val() + ":00Z";
          }

          // Check if school is selected
          if (!schoolSelected && isLive) {
            alert("Please select a school from the list");
            return;
          }

          const queryString = window.location.search;
          const urlParams = new URLSearchParams(queryString);

          var job_title_value = $("#job_title_select").find(":selected").val();

          // Build body json
          let body = {
            sales_lead: {
              first_name: $('input[name="first_name"]').val(),
              last_name: $('input[name="last_name"]').val(),
              email: $('input[name="email"]').val(),
              phone_number: $('input[name="phone"]').val(),
              // job_title: $('input[name="job_title"]').val(),
              job_title: job_title_value,
              organisation: $('input[name="organisation"]').val(),
              urn: $('input[name="school_urn"]').val(),
              sales_leadable_type: "MarketingFormSubmission",
              sales_leadable_attributes: {
                utm_campaign: urlParams.get("utm_campaign"),
                utm_medium: urlParams.get("utm_medium"),
                utm_source: urlParams.get("utm_source"),
                utm_content: urlParams.get("utm_content"),

                utm_term: urlParams.get("utm_term"),
                utm_creative_format: urlParams.get("utm_creative_format"),
                utm_keyword: urlParams.get("utm_keyword"),
                utm_marketing_tactic: urlParams.get("utm_marketing_tactic"),
                utm_source_platform: urlParams.get("utm_source_platform"),
                placement: urlParams.get("placement"),
                site_source_name: urlParams.get("site_source_name"),

                data: {
                  preferred_call_back_time: preferred_call_back_time,
                  opted_in_for_marketing: "false",
                },
              },
            },
          };

          console.log(body);

          // Grey out form during submission
          $(".leadForm").append(
            '<div id="form-loading" class="absolute inset-0 bg-white bg-opacity-50 flex items-center justify-center"></div>'
          );

          // Submit
          $.ajax({
            url: apiUrl + "/sales_leads",
            type: "POST",
            data: body,
            success: function (response) {
              console.log("Form Submitted: ", response);
              $(".leadForm").html(
                '<div class="text-center text-white text-2xl">Thank you for registering your interest. We will be in touch soon.</div>'
              );
              // Add scroll to the success message.
              $("html, body").animate(
                {
                  scrollTop: $(".leadForm").offset().top - 300,
                },
                1000
              );
            },
            error: function ( jXHR, textStatus, errorThrown ) {
              console.log("Error: ", errorThrown);
              console.log("textStatus: ", textStatus);
              const errors = jXHR.responseJSON.errors;
              console.log('Errors: ', errors);
              let error = '';
              if ( errors ) {
                error = errors.join('<br/>');
              }
              if ( error.toLowerCase().includes('urn') || error.toLowerCase().includes('school') ) {
                $('input[name="school_name"]').addClass('input-error');
                $('input[name="school_name"]').after(`<p class="input-error-message">Please select a school from the list</p>`);
              }
              $(".form-error").removeClass("hidden").html('Please correct the errors below.');
              $('#form-loading').remove();
              // Add scroll to the fail message.
              $("html, body").animate(
                {
                  scrollTop: $(".form-error").offset().top - 300,
                },
                1000
              );
            },
          });

          // Log Form Data for Debugging
          // console.log('Form Data: ', body);
        });

        // Marketing Form Submission
        $(".marketingForm").submit(function (e) {
          e.preventDefault();
          console.log("Marketing Form Submitted");
          const is_valid = validateForm($(this));

          if ( ! is_valid ) {
            return;
          }

          // Get Preferred Call Back Time and format to “2024-07-22T11:00:00Z”
          let preferred_call_back_time = null;
          if ($("#form_date").val() && $("#form_time").val()) {
            preferred_call_back_time =
              $("#form_date").val() + "T" + $("#form_time").val() + ":00Z";
          }

          // Check if school is selected
          if (!schoolSelected && isLive) {
            alert("Please select a school from the list");
            return;
          }

          const queryString = window.location.search;
          const urlParams = new URLSearchParams(queryString);

          var job_title_value = $("#job_title_select").find(":selected").val();

          // Build body json for marketing_engagements API
          let body = {
            marketing_engagement: {
              first_name: $('input[name="first_name"]').val(),
              last_name: $('input[name="last_name"]').val(),
              email: $('input[name="email"]').val(),
              phone_number: $('input[name="phone"]').val(),
              job_title: job_title_value,
              urn: $('input[name="school_urn"]').val(),
              activity_code: $('input[name="activity_code"]').val(),
              activity_score: $('input[name="activity_score"]').val(),
              utm_campaign: urlParams.get("utm_campaign"),
              utm_medium: urlParams.get("utm_medium"),
              utm_source: urlParams.get("utm_source"),
              utm_content: urlParams.get("utm_content"),
              utm_term: urlParams.get("utm_term"),
              utm_creative_format: urlParams.get("utm_creative_format"),
              utm_keyword: urlParams.get("utm_keyword"),
              utm_marketing_tactic: urlParams.get("utm_marketing_tactic"),
              utm_source_platform: urlParams.get("utm_source_platform"),
              meta_placement: urlParams.get("placement"),
              meta_site_source_name: urlParams.get("site_source_name"),
              data: {
                preferred_call_back_time: preferred_call_back_time,
                opted_in_for_marketing: $('input[name="contact-by-email"]').is(":checked") ? 1 : 0,
              },
            },
          };

          console.log('Marketing form body: ', body);

          // Grey out form during submission
          $(".marketingForm").append(
            '<div id="form-loading" class="absolute inset-0 bg-white bg-opacity-50 flex items-center justify-center"></div>'
          );

          // Submit
          $.ajax({
            url: apiUrl + "/marketing_engagements",
            type: "POST",
            data: body,
            success: function (response) {
              console.log("Form Submitted: ", response);
              $(".marketingForm").html(
                '<div class="text-center text-white text-2xl">Thank you for registering your interest. We will be in touch soon.</div>'
              );
              // Add scroll to the success message.
              $("html, body").animate(
                {
                  scrollTop: $(".marketingForm").offset().top - 300,
                },
                1000
              );
            },
            error: function ( jXHR, textStatus, errorThrown ) {
              console.log("Error: ", errorThrown);
              console.log("textStatus: ", textStatus);
              const errors = jXHR.responseJSON.errors;
              console.log('Errors: ', errors);
              let error = '';
              if ( errors ) {
                error = errors.join('<br/>');
              }
              if ( error.toLowerCase().includes('urn') ) {
                $('input[name="school_name"]').addClass('input-error');
                $('input[name="school_name"]').after(`<p class="input-error-message">Please enter your school name and select it from the list.</p>`);
              }
              $(".form-error").removeClass("hidden").html('Please correct the errors below.');
              $('#form-loading').remove();
              // Add scroll to the fail message.
              $("html, body").animate(
                {
                  scrollTop: $(".form-error").offset().top - 300,
                },
                1000
              );
            },
          });

        });

        // School Name Search
        $(".schoolNameSearch input").on("keyup", function () {
          // Clear Timeout
          clearTimeout(searchTimeout);

          schoolName = $(this).val();

          // Set Timeout to search after 500ms of idle to give user time to type
          searchTimeout = setTimeout(function () {
            $(".schoolNameSearch .spinner").removeClass("opacity-0");

            if (schoolName.length > 2 && !searching) {
              findSchool(schoolName);
            } else {
              // clear schools
              $(".schoolNameSearchContainer").html("").hide();
            }
          }, 500);
        });

        // Off Focus, hide school search container
        $(".schoolNameSearch input").on("focusout", function () {
          setTimeout(() => {
            if (!schoolSelected) {
              $(".schoolNameSearchContainer").hide();
            }
          }, 200);
        });

        // On Focus, show school search container
        $(".schoolNameSearch input").on("focus", function () {
          if (schools.length > 0 && !searching && !schoolSelected) {
            $(".schoolNameSearchContainer").show();
          }
        });
      });
    }
  }
}
